import { useEffect } from 'react';

let instanceCount = 0;
let originalOverflow: string;

const useDisabledBodyScrolling = () => {
  useEffect(() => {
    if (instanceCount++ === 0) {
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    return () => {
      if (--instanceCount === 0) {
        document.body.style.overflow = originalOverflow;
      }
    };
  });
};

export default useDisabledBodyScrolling;
